import { CHANGE_SELECTED_COLUMNS } from "../actions/types";

const selectedReportColumns = (state = {}, action) => {
  switch (action.type) {
    case CHANGE_SELECTED_COLUMNS:
      return { ...state, [action.payload.reportKey]: action.payload.columns };
    default:
      return state;
  }
};

export const setSelectedColumnsAction = (reportKey, columns) => ({
  type: CHANGE_SELECTED_COLUMNS,
  payload: { reportKey, columns },
});


export default selectedReportColumns;
